import React from 'react';
import { motion } from 'framer-motion';
import './Process.css';

const steps = [
  { n: '01', title: 'Site Survey & Design', body: 'Drone-based irradiance mapping and shadow analysis. Our engineers design a system tuned to your roof, load profile, and local grid.' },
  { n: '02', title: 'Manufacturing', body: 'Modules, inverters, and batteries built in our GW-scale fabs with 100% EL inspection and traceable component-level QC.' },
  { n: '03', title: 'Installation', body: 'Certified partners handle structural mounting, wiring, and commissioning — typically in 3–7 days for residential, 8–16 weeks for utility.' },
  { n: '04', title: 'Monitoring & Care', body: 'Helios platform tracks every string in real time. 24/7 response SLAs, predictive maintenance, and lifetime performance optimization.' },
];

export default function Process() {
  return (
    <section id="process" className="process">
      <div className="container">
        <motion.div
          className="process-head"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="eyebrow">How we deliver</span>
          <h2 className="section-title">
            From <span className="accent">first sunrise</span> to lifetime care.
          </h2>
          <p className="section-lead">
            A single accountable partner for the full lifecycle — design, manufacturing,
            installation, and proactive monitoring under one roof.
          </p>
        </motion.div>

        <div className="process-timeline">
          <div className="timeline-track" />
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              className="timeline-step"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
            >
              <div className="step-node">
                <span>{s.n}</span>
              </div>
              <div className="step-card glass">
                <h3>{s.title}</h3>
                <p>{s.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
